import { render, staticRenderFns } from "./Quakewatch.vue?vue&type=template&id=40992bc6&"
import script from "./Quakewatch.vue?vue&type=script&lang=js&"
export * from "./Quakewatch.vue?vue&type=script&lang=js&"
import style0 from "./Quakewatch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports